import React from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import useStyles from './styles';
import AppConstants from '../../../common/constants/AppConstants';

export default function HelpPage() {
  const classes = useStyles();
  const { t } = useTranslation();
  const linksList = AppConstants?.help?.helpLinks
    ? AppConstants.help.helpLinks
    : [];

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Typography className={classes.title}>
          {' '}
          {t('Reference Links')}
        </Typography>
        <Paper elevation={0} className={classes.contentPaper}>
          <div className={classes.helpDiv} data-testid="help-links-list">
            <ul className={classes.links_list}>
              {linksList.map((link) => (
                <li key={link.title}>
                  <a href={link.link} target="_blank" rel="noreferrer">
                    {t(link.title)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </Paper>
      </Grid>
    </div>
  );
}
